import { isEmpty } from 'lodash';

const TEMPLATE_NAME = 'PRESCRIPTION_CONSOLIDATE_PEP';

const initialState = () => ({
  loading: false,
  loadedData: [],
  filter: {
    term: '',
    data: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const { prescriptionsItems, prescriptions } = action.payload;
      const headerItem = {
        id: 0,
        name: 'Header Item',
        history: prescriptions
      };

      let prescriptionsConsolidated = [];

      if (isEmpty(prescriptions) || isEmpty(prescriptionsItems)) {
        prescriptionsConsolidated = [];
      } else {
        prescriptionsConsolidated = [headerItem, ...prescriptionsItems];
      }

      return {
        ...state,
        loading: false,
        loadedData: prescriptionsConsolidated,
        filter: {
          ...state.filter,
          data: prescriptionsConsolidated
        }
      };
    }
    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
